export default {
    baseStyle: ({isGiftCard}) => ({
        container: {
            width: '100%',
            cursor: 'pointer',
            color: 'webTypo.textPrimary'
        },
        imageWrapper: {
            position: 'relative',
            mb: 2,
            bgColor: isGiftCard ? 'webTheme.backgroundPrimaryBrand' : 'webTheme.layerDefault'
        },
        mediaAspect: {
            ratio: 17 / 25,
            width: '100%'
        },
        qvOverlay: {
            position: 'absolute',
            bottom: 2,
            right: 2,
            zIndex: 1,
            opacity: {base: 1, md: 0},
            _groupHover: {opacity: 1},
            transition: 'opacity 0.2s'
        },
        productName: {
            textStyle: 'labelXs',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            mb: 1
        },
        productPrice: {
            textStyle: 'labelXs'
        },
        skeletonWrapper: {
            width: '100%'
        },
        skeletonAspectRatio: {
            mb: 2
        },
        skeletonImage: {
            borderRadius: 'md'
        },
        skeletonNameLine: {
            height: '12px',
            mb: 1,
            borderRadius: 'sm'
        },
        skeletonPriceLine: {
            height: '12px',
            width: '60%',
            borderRadius: 'sm'
        }
    })
}
